export default "__VITE_ASSET__MRh2LpGp__"